import React from "react";
import { Typography } from "@mui/material";
import { formatInTimeZone } from "date-fns-tz";

const CaregiverSignature = (props) => {
  const { classes, billableItem, startDate, endDate, timezone } = props;

  return billableItem?.start_signature_url ? (
    <div className={classes.signatureContainer}>
      <div className={classes.signatureTitleContainer}>
        <Typography variant="h4">Designated Caregiver Signature</Typography>
      </div>
      <div className={classes.disabledSignatureCanvasContainer}>
        <img className={classes.signatureImage} src={billableItem.start_signature_url} />
      </div>
      <Typography
        component="p"
        variant="body2"
        color="text.secondary"
        style={{ fontStyle: "italic" }}
      >
        {`The designated caregiver confirms that the video session took place on 
        ${formatInTimeZone(new Date(startDate), timezone, "MMMM d, yyyy")} from ${formatInTimeZone(
          new Date(startDate),
          timezone,
          "h:mm a"
        )} - ${formatInTimeZone(new Date(endDate), timezone, "h:mm a zzz")} `}
      </Typography>
    </div>
  ) : null;
};

export default CaregiverSignature;
